<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite lokacijo printanja:
    </h2>

    <LocationForm
      :barve="false"
      @save="save"
      @cancel="cancel"
      :location="location"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import LocationForm from '@/components/LocationForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    LocationForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
    }
  },
  computed: {
    location () {
      return this.$store.state.printerslocations.items[this.id]
    }
  },
  methods: {
    ...mapActions('printerslocations', ['loadItem', 'saveItem']),
    save ({ data }) {
      saveItem(data, '-1', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyPrintersLocations' })
    }
  },
  created () {
    this.loadItem(this.id)
      .then(item => {
        this.asyncDataStatus_fetched()
      })
  }
}
</script>
